/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-card-title[_ngcontent-%COMP%]{background:#e4e4e3;padding:10px 20px}.nsc-card-title[_ngcontent-%COMP%]     h2, .nsc-card-title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin:0}.nsc-card-title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{display:inline}.nsc-card-title--error[_ngcontent-%COMP%]{background:#b30c1c;color:#fff}.nsc-card-title__note[_ngcontent-%COMP%]{color:#000;display:block;opacity:.8}@media (min-width:768px){.nsc-card-title__note[_ngcontent-%COMP%]{display:inline;padding-left:1em}}"];
export { styles as styles };
